import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

import posexIcon from './navbar_icon/PoseX.png';
import posexIconOn from './navbar_icon/PoseX_on.png';
import leaderboardIcon from './navbar_icon/Leaderboard.png';
import leaderboardIconOn from './navbar_icon/Leaderboard_on.png';


const Navbar = () => {
  const location = useLocation(); // Get current location
  const navigate = useNavigate(); // Get navigate function
  const [isScrolled, setIsScrolled] = useState(false);

  const isLeaderboardRoute = useMemo(() => {
    return location.pathname === '/leaderboard' || location.pathname.startsWith('/leaderboard/');
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePoseXClick = (event) => {
    if (location.pathname === '/') {
      event.preventDefault();
      scrollToTop();
      return;
    }

    navigate('/');
    setTimeout(scrollToTop, 80);
  };

  useEffect(() => {
    const updateScrolledState = () => {
      if (location.pathname !== '/') {
        setIsScrolled(true);
        return;
      }

      const bannerElement = document.querySelector('.home-background');
      if (!bannerElement) {
        setIsScrolled(window.scrollY > 10);
        return;
      }

      const navbarHeight = 64;
      const bannerBottom = bannerElement.getBoundingClientRect().bottom;
      setIsScrolled(bannerBottom <= navbarHeight);
    };

    updateScrolledState();
    window.addEventListener('scroll', updateScrolledState, { passive: true });
    window.addEventListener('resize', updateScrolledState);

    return () => {
      window.removeEventListener('scroll', updateScrolledState);
      window.removeEventListener('resize', updateScrolledState);
    };
  }, [location.pathname]);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar-container">
        <Link
          to="/"
          className="navbar-icon-link"
          aria-label="PoseX Home"
          onClick={handlePoseXClick}
        >
          <img
            src={isScrolled ? posexIconOn : posexIcon}
            alt="PoseX"
            className="navbar-icon"
          />
        </Link>

        <button
          type="button"
          className="navbar-icon-button"
          aria-label="Leaderboard"
          onClick={() => navigate('/leaderboard')}
        >
          <img
            src={isLeaderboardRoute || isScrolled ? leaderboardIconOn : leaderboardIcon}
            alt="Leaderboard"
            className="navbar-icon navbar-icon--leaderboard"
          />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;